<template>
  <article class="edifice" :class="{'show-descriptions' : showDescriptions}">
    <div class="container container-small">
      <div
        class="edifice-wrapper"
        :class="{
          'is-fixed': isFixed,
          'is-absolute-bottom': isAbsoluteBottom
        }"
        :style="{
          top: edificeTop +'px',
          height: edificeHeight +'px'
        }"
      >
        <section v-for="(section, index) in edifice" :class="{active: activeItem === index}" :key="index" :style="{'z-index': 100 - index}"  @click="activeItem = index">
          <header class="description" v-if="section.header">
            <div class="description-header">
              <svg class="arrow-big">
                <use class="default use-contrast" xlink:href="#tringleSvg"></use>
                <use class="on-active use-contrast" xlink:href="#tringleContrastSvg"></use>
                <use class="default" xlink:href="#tringleDarkSvg"></use>
                <use class="on-active" xlink:href="#tringleAccentSvg"></use>
              </svg>
              <div v-if="section.icon" class="edifice-icon">
                <img :src="section.icon" :alt="section.header" />
              </div>
              <h3 v-else class="text-xl" v-accent="section.header"></h3>
            </div>
            <p class="text-m" v-accent="section.description"></p>
            <ul class="text-m">
              <li v-for="(item, itemIndex) in section.list" :key="itemIndex">
                <svg>
                  <use class="use-default" xlink:href="#tringleDarkSvg"></use>
                  <use class="use-contrast" xlink:href="#tringleContrastSvg"></use>
                </svg>
                <span v-accent="item"></span>
              </li>
            </ul>
          </header>
          <img v-if="section.image" :src="section.image" :alt="section.header" class="section-img" />
        </section>
      </div>
    </div>
  </article>
</template>

<script>

export default {
  name: 'edificeSection',
  props: ['edifice'],
  data () {
    return {
      showDescriptions: false,
      ticking: false,
      windowHeight: 0,
      animated: {},
      edificeTop: 100,
      edificeHeight: 120,
      isFixed: false,
      isAbsoluteBottom: false,
      activeItem: null
    }
  },
  methods: {
    handleScroll (event) {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          if (window.pageYOffset > this.$el.offsetTop - this.windowHeight / 2 && window.pageYOffset < this.$el.offsetTop + this.windowHeight / 2) {
            this.isFixed = true
            this.isAbsoluteBottom = false
            this.setHeight(window.pageYOffset - this.$el.offsetTop + this.windowHeight / 4)
            if (this.edificeHeight > 250) {
              this.showDescriptions = true
            } else {
              this.showDescriptions = false
              this.activeItem = null
            }
          } else if (window.pageYOffset > this.$el.offsetTop + this.windowHeight / 2 && window.pageYOffset < this.$el.offsetTop + this.windowHeight) {
            this.showDescriptions = true
            this.isFixed = true
            this.isAbsoluteBottom = false
            this.setHeight(window.pageYOffset - this.$el.offsetTop)
          } else if (window.pageYOffset > this.$el.offsetTop + this.windowHeight / 2) {
            this.isAbsoluteBottom = true
            this.isFixed = false
            this.showDescriptions = true
          } else {
            this.isFixed = false
            this.isAbsoluteBottom = false
            this.showDescriptions = false
          }
          this.ticking = false
        })
        this.ticking = true
      }
    },
    setHeight (offset) {
      this.edificeHeight = Math.min(Math.max(120, offset * 2), 610)
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted () {
    this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.documentElement.getElementsByTagName('body')[0].clientHeight
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="scss">
  .arrow-big {
    .on-active {
      display: none;
    }
  }
  .edifice {
    display: block;
    justify-content: space-between;
    padding: 40px 0 0;
    height: 100vh;
    // height: calc(100vh + 140px);
    min-height: 1070px;
    position: relative;
    .container {
      height: 100%;
    }

    &-wrapper {
      position: absolute;
      top: 100px;
      left: 50%;
      width: 34vw;
      max-width: 390px;
      transform: translateX(-50%);
      margin: 0 auto;
      height: 200px;
      max-height: 48%;
      // &.is-fixed {
      //   position: fixed;
      // }
      // &.is-absolute-bottom {
      //   top: auto !important;
      //   bottom: calc(46vh - 100px);
      // }
    } // END .edifice-wrapper;

    &-icon {
      text-align: right;

      img {
        height: 80px;
        margin: 0;
        width: 80px !important;
      }
    } // END .edifice-icon;
  }
  .description {
    text-align: left;
    position: absolute;
    top: 30%;
    left: -90px;
    width: 228px;
    transform: translateX(-100%);
    transition: $transition;
    opacity: 0;
    background-color: $bg-light;

    &-header {
      position: relative;
    } // END .description-header;

    p, ul {
      transition: $transition;
      opacity: 0;
      height: 0;
      margin: 0;
      font-weight: 500;
    }
    ul {
      list-style: none;
      padding: 0;
      li {
        margin: 4px 0;
        position: relative;
        svg {
          width: 14px;
          height: 14px;
          position: absolute;
          top: 6px;
          left: -30px;
        }
      }
    }
    .arrow-big {
      position: absolute;
      top: 50%;
      margin-top: -24px;
      right: -70px;
      width: 48px;
      height: 48px;
    }
    @include desktop-small {
      // width: 200px;
      left: -50px;
    }
    @include tablet {
      width: 200px;
      left: -25px;
      .arrow-big {
        right: -45px;
      }
      ul li svg {
        left: -20px;
      }
    }
  }
  section {
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    min-height: 50px;
    height: 190px;
    cursor: pointer;
    &.active {
      .show-descriptions & {
        .description {
          opacity: 1;
          h3 {
            color: $text-accent;
          }
          p, ul {
            opacity: 1;
            height: auto;
            margin: 0;
            padding: 16px 0;
          }
        }
        .arrow-big {
          .default {
            display: none;
          }
          .on-active {
            display: block;
          }
        }
      }
    }
    &:hover {
      .show-descriptions & {
        .description {
          opacity: 1;
          h3 {
            color: $text-accent;
          }
        }
        .arrow-big {
          .default {
            display: none;
          }
          .on-active {
            display: block;
          }
        }
      }
    }
    &:nth-child(1) {
      top: 0;
    }
    &:nth-child(2) {
      top: 27%;
      .section-img {
        width: 84%;
      }
    }
    &:nth-child(3) {
      top: 50%;
      .section-img {
        width: 84%;
      }
      .description {
        top: 3%;
      }
    }
    &:nth-child(4) {
      top: 75%;
      .section-img {
        width: 84%;
      }
      .description {
        top: 64%;
      }
    }
    &:nth-child(5) {
      top: 100%;
      .section-img {
        width: 110%;
        margin-left: -5%;
      }
      .description {
        top: 7%;
      }
    }
    &:nth-child(2n) {
      .description {
        left: auto;
        right: -90px;
        transform: translateX(100%);

        .edifice-icon {
          text-align: left;
        }

        @include desktop-small {
          right: -50px;
        }
        @include tablet {
          right: -25px;
        }
        .arrow-big {
          right: auto;
          left: -70px;
          // top: -20px;
          transform: rotate(180deg);
          transform-origin: center;
          @include tablet {
            left: -45px;
          }
        }
      }
    }
    .section-img {
      width: 100%;
      display: block;
      margin: 0 auto;
    }
    .description {
      h3 {
        margin: 0;
      }
      .show-descriptions & {
        opacity: 0.3;
        display: block;
        // &:hover {
        //   opacity: 1;
        //   h3 {
        //     color: $text-accent;
        //     margin: 0 0 28px;
        //   }
        //   p, ul {
        //     opacity: 1;
        //     height: auto;
        //     margin: 16px 0;
        //   }
        // }
      }
    }
  }
</style>
